export default __webpack_public_path__ + "static/media/IconF4.7989f4e8.svg";